import { Component } from '@angular/core';
import { AscendEaglesoftBlockerComponent } from '../ascend-eaglesoft-blocker/ascend-eaglesoft-blocker.component';

@Component({
  selector: 'lib-installation-pending',
  imports: [AscendEaglesoftBlockerComponent],
  templateUrl: './installation-pending.component.html',
  styleUrl: './installation-pending.component.scss',
})
export class InstallationPendingComponent {}
